/**
 * DeWalt overlays — Consentmo cookie banner restyle (shadow DOM).
 * Klaviyo floating UI is hidden via drawers-dewalt.css; BIS uses theme drawer.
 * Also strip Klaviyo’s body scroll-lock class (popup is hidden, lock would stick).
 */
(function () {
  if (!document.body || !document.body.classList.contains('dewalt')) return;

  var KLAVIYO_LOCK = 'klaviyo-prevent-body-scrolling';

  function clearKlaviyoScrollLock() {
    if (!document.body.classList.contains(KLAVIYO_LOCK)) return;
    document.body.classList.remove(KLAVIYO_LOCK);
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('height');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('left');
  }

  clearKlaviyoScrollLock();
  new MutationObserver(clearKlaviyoScrollLock).observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  var STYLE_ID = 'dewalt-csm-style';

  var css = [
    ':host, .csm-wrapper, .csm-dialog, .csm-ccd-panel {',
    '  font-family: Inter, system-ui, sans-serif !important;',
    '  border-radius: 0 !important;',
    '}',
    '.csm-dialog, .csm-ccd-panel, [role="dialog"] {',
    '  --csm-cc-background: #ffffff !important;',
    '  --csm-cc-color: #231e20 !important;',
    '  --csm-cc-button-color: #febd17 !important;',
    '  --csm-cc-button-text-color: #231e20 !important;',
    '  --csm-cc-switcher-active: #febd17 !important;',
    '  --csm-cc-switcher-inactive: #ced4d4 !important;',
    '  --button-color: #febd17 !important;',
    '  --button-color-hover: #e5ab15 !important;',
    '  --button-text-color: #231e20 !important;',
    '  --button-border-radius: 0 !important;',
    '  --banner-text-color: #231e20 !important;',
    '  --switcher-color-active: #febd17 !important;',
    '  --switcher-color-inactive: #ced4d4 !important;',
    '  background: #ffffff !important;',
    '  color: #231e20 !important;',
    '  box-shadow: 0 -8px 24px rgba(0,0,0,0.12) !important;',
    '  border: 1px solid #ced4d4 !important;',
    '  border-top: 4px solid #febd17 !important;',
    '}',
    '.csm-ccd-header-text, .csm-ccd-header-wrapper {',
    '  font-family: Archivo, Inter, sans-serif !important;',
    '  font-weight: 800 !important;',
    '  letter-spacing: 0.04em !important;',
    '  text-transform: uppercase !important;',
    '  color: #231e20 !important;',
    '}',
    '.csm-ccd-body, .csm-ccd-cookie-text, .cc-message, .isense-cc-message, p {',
    '  color: #3c4143 !important;',
    '  font-size: 14px !important;',
    '  line-height: 1.45 !important;',
    '}',
    'a, .cc-link, .isense-cc-link {',
    '  color: #231e20 !important;',
    '  text-decoration: underline !important;',
    '  text-underline-offset: 2px !important;',
    '}',
    '.csm-ccd-category-item, [id*="csm-dialog-cookie-"][id$="-section-info"] {',
    '  font-family: Archivo, Inter, sans-serif !important;',
    '  font-weight: 700 !important;',
    '  font-size: 13px !important;',
    '  letter-spacing: 0.02em !important;',
    '  color: #231e20 !important;',
    '}',
    'hr {',
    '  border: 0 !important;',
    '  border-top: 1px solid #ced4d4 !important;',
    '  opacity: 1 !important;',
    '}',
    '.csm-dialog-switch {',
    '  --switcher-color-active: #febd17 !important;',
    '  --switcher-color-inactive: #ced4d4 !important;',
    '}',
    /* High-specificity overrides — Consentmo ships !important teal rules */
    '.csm-dialog .csm-dialog-switch .csm-slider,',
    '.csm-dialog .csm-dialog-switch .csm-slider.round,',
    '.csm-ccd-panel .csm-dialog-switch .csm-slider,',
    '.csm-wrapper .csm-slider.round {',
    '  border-radius: 0 !important;',
    '  background: #ced4d4 !important;',
    '  background-color: #ced4d4 !important;',
    '}',
    '.csm-dialog .csm-dialog-switch.active .csm-slider,',
    '.csm-dialog .csm-dialog-switch.active .csm-slider.round,',
    '.csm-ccd-panel .csm-dialog-switch.active .csm-slider,',
    '.csm-wrapper .csm-dialog-switch.active .csm-slider.round {',
    '  background: #febd17 !important;',
    '  background-color: #febd17 !important;',
    '}',
    '.csm-dialog .csm-dialog-switch .csm-slider::before,',
    '.csm-wrapper .csm-slider.round::before {',
    '  border-radius: 0 !important;',
    '  background: #ffffff !important;',
    '  background-color: #ffffff !important;',
    '  box-shadow: 0 1px 2px rgba(0,0,0,0.18) !important;',
    '}',
    '.cc-compliance, .isense-cc-compliance, .csm-ccd-buttons-wrapper {',
    '  --button-color: #febd17 !important;',
    '  --button-color-hover: #e5ab15 !important;',
    '  --button-text-color: #231e20 !important;',
    '  --button-border-radius: 0 !important;',
    '  gap: 8px !important;',
    '}',
    'button, .csm-btn, [class*="csm-btn"], [class*="cc-btn"] {',
    '  border-radius: 0 !important;',
    '  font-family: Archivo, Inter, sans-serif !important;',
    '  font-weight: 800 !important;',
    '  letter-spacing: 0.04em !important;',
    '  text-transform: uppercase !important;',
    '  min-height: 44px !important;',
    '  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease !important;',
    '}',
    'button[data-csm-button-type="accept"],',
    'button[class*="allow"], button[class*="accept"],',
    '[class*="cc-allow"], [class*="cc-accept"], [class*="btn-allow"], [class*="btn-accept"],',
    '.isense-cc-allow, .isense-cc-submit-consent {',
    '  background: #febd17 !important;',
    '  background-color: #febd17 !important;',
    '  border: 1px solid #febd17 !important;',
    '  color: #231e20 !important;',
    '  --csm-button-background-color: #febd17 !important;',
    '  --csm-button-text-color: #231e20 !important;',
    '  --csm-button-outline-color: #febd17 !important;',
    '  --csm-button-border-radius: 0 !important;',
    '}',
    'button[data-csm-button-type="accept"]:hover,',
    'button[class*="allow"]:hover, button[class*="accept"]:hover,',
    '[class*="cc-allow"]:hover, .isense-cc-allow:hover {',
    '  background: #e5ab15 !important;',
    '  background-color: #e5ab15 !important;',
    '  border-color: #e5ab15 !important;',
    '  color: #231e20 !important;',
    '}',
    'button[data-csm-button-type="preferences"],',
    'button[class*="settings"], button[class*="pref"], [class*="cc-settings"],',
    '.isense-cc-settings {',
    '  background: #ffffff !important;',
    '  background-color: #ffffff !important;',
    '  border: 1px solid #ced4d4 !important;',
    '  color: #231e20 !important;',
    '  --csm-button-background-color: #ffffff !important;',
    '  --csm-button-text-color: #231e20 !important;',
    '  --csm-button-outline-color: #ced4d4 !important;',
    '  --csm-button-border-radius: 0 !important;',
    '}',
    'button[data-csm-button-type="preferences"]:hover,',
    'button[class*="settings"]:hover, [class*="cc-settings"]:hover {',
    '  border-color: #231e20 !important;',
    '  color: #231e20 !important;',
    '}',
    'button[class*="deny"], button[class*="reject"], button[class*="Deny"],',
    '[class*="cc-deny"], [class*="cc-dismiss"], [class*="btn-deny"] {',
    '  background: #ffffff !important;',
    '  border: 1px solid #231e20 !important;',
    '  color: #231e20 !important;',
    '}'
  ].join('\n');

  function paintSliders(root) {
    root.querySelectorAll('.csm-slider').forEach(function (slider) {
      var on = slider.closest('.csm-dialog-switch') &&
        slider.closest('.csm-dialog-switch').classList.contains('active');
      var color = on ? '#febd17' : '#ced4d4';
      slider.style.setProperty('background', color, 'important');
      slider.style.setProperty('background-color', color, 'important');
      slider.style.setProperty('border-radius', '0', 'important');
    });
  }

  function inject(root) {
    if (!root || painting) return;
    painting = true;
    try {
      var style = root.getElementById(STYLE_ID);
      if (!style) {
        style = document.createElement('style');
        style.id = STYLE_ID;
      }
      if (style.textContent !== css) style.textContent = css;
      /* Always move to end so we beat Consentmo’s linked stylesheet */
      if (style.parentNode !== root || style !== root.lastChild) {
        root.appendChild(style);
      }

      var dialog = root.querySelector('.csm-dialog, .csm-ccd-panel, [role="dialog"]');
      if (dialog) {
        dialog.style.setProperty('--csm-cc-button-color', '#febd17');
        dialog.style.setProperty('--csm-cc-button-text-color', '#231e20');
        dialog.style.setProperty('--csm-cc-switcher-active', '#febd17');
        dialog.style.setProperty('--csm-cc-switcher-inactive', '#ced4d4');
        dialog.style.setProperty('--csm-cc-color', '#231e20');
        dialog.style.setProperty('--csm-cc-background', '#ffffff');
      }

      root.querySelectorAll('.csm-dialog-switch').forEach(function (el) {
        el.style.setProperty('--switcher-color-active', '#febd17');
        el.style.setProperty('--switcher-color-inactive', '#ced4d4');
      });

      paintSliders(root);
    } finally {
      painting = false;
    }
  }

  var shadowObserved = false;
  var painting = false;
  var attached = false;

  function observeShadow(root) {
    if (shadowObserved || !root) return;
    shadowObserved = true;
    var shadowObserver = new MutationObserver(function () {
      if (painting) return;
      inject(root);
    });
    // Never observe `style` — inject() writes style attrs and would re-enter
    // forever (Safari desktop freeze on DeWalt pages).
    shadowObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function tryAttach() {
    if (attached) return;
    var host = document.querySelector('csm-cookie-consent');
    if (host && host.shadowRoot) {
      inject(host.shadowRoot);
      observeShadow(host.shadowRoot);
      attached = true;
      if (observer) observer.disconnect();
      if (timer) clearInterval(timer);
    }
  }

  var observer = new MutationObserver(function () {
    tryAttach();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var n = 0;
  var timer = setInterval(function () {
    tryAttach();
    if (++n > 40) clearInterval(timer);
  }, 250);

  tryAttach();

  document.addEventListener('consentmoSignal_onLoad', tryAttach);
  document.addEventListener('consentmoSignal', tryAttach);
})();
